import { Button, Form, Input, Spin, notification } from "antd";
import React, { useState, useCallback } from "react";
import PasswordIcon from "@assets/icon/PasswordIcon";
import WarningIcon from "@assets/icon/WarningIcon";
import Footer from "@components/Layout/Footer";
import { authPostData } from "@utils/request";
import { useNavigate } from "react-router-dom";
import { SmileOutlined } from "@ant-design/icons";
import LogoComponent from "../../components/Layout/Logo";
import { setEmail } from "@redux/Date/DateReducer";
import { useDispatch, useSelector } from "react-redux";

export default function ChangingPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const email = useSelector((state) => state.date.email);
  const onFinish = useCallback((values) => {
    authPostData({
      url: "api/v1/user/forgot-pwd/confirm",
      method: "POST",
      payload: values,
      setLoading,
      setImportLoading: () => {},
      onSuccess: (res) => {
        if (res.statusCode === 200) {
          notification.open({
            message: "Thành công",
            description: res.message,
            icon: <SmileOutlined style={{ color: "#108ee9" }} />,
          });
          navigate("/changing-password-success");
        } else {
          setLoading(false);
        }
      },
    });
  }, []);

  const resendOtp = () => {
    if (email) {
      const formData = {
        Email: email,
      };
      authPostData({
        url: "api/v1/user/otp-resend",
        method: "POST",
        payload: formData,
        setLoading,
        setImportLoading: () => {},
        onSuccess: (res) => {
          if (res.statusCode === 200) {
            notification.open({
              message: "Thành công",
              description: "Gửi lại mã OTP thành công - Vui lòng check Mail",
              icon: <SmileOutlined style={{ color: "#108ee9" }} />,
            });
            navigate("/changing-password");
          } else {
            setLoading(false);
          }
        },
      });
    } else {
      notification.error({
        duration: 3,
        message: "Thông báo!",
        description: "Bạn chưa nhập email",
      });
    }
  };
  return (
    <Spin spinning={loading}>
      <div style={{ backgroundColor: "#e5e5e5" }}>
        <div className="login-container">
          <LogoComponent />
          <div className="login-form">
            <div className="form-title">
              <span>Đặt lại mật khẩu</span>
            </div>
            <div className="form-description">
              <span>Vùi lòng nhập mật khẩu mới</span>
            </div>
            <Form
              // form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
              className="form-login"
            >
              <Form.Item
                name="newPassword"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập mật khẩu",
                  },
                  {
                    validator(rule, value) {
                      if (!value || value.length >= 8) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        "Mật khẩu mới yêu cầu tối thiểu 8 ký tự"
                      );
                    },
                  },
                ]}
              >
                <Input.Password
                  className="form-input"
                  size="large"
                  placeholder="Nhập mật khẩu mới"
                  prefix={<PasswordIcon style={{ marginRight: "12px" }} />}
                />
              </Form.Item>
              <div className="form-password-advice">
                <WarningIcon className="form-password-advice-icon" />
                <span>Mật khẩu mới yêu cầu tối thiểu 8 ký tự</span>
              </div>
              <Form.Item
                name="confirmPassword"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Xác nhận lại mật khẩu",
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("newPassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        "Mật khẩu xác nhận không trùng khớp"
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  className="form-input-password-again form-input"
                  size="large"
                  placeholder="Xác nhận mật khẩu"
                  prefix={<PasswordIcon style={{ marginRight: "12px" }} />}
                />
              </Form.Item>
              <Form.Item name="code">
                <Input.Password
                  className="form-input-password-again form-input"
                  size="large"
                  placeholder="Nhập mã OTP"
                />
              </Form.Item>

              <div className="form-resend-link">
                <span>Bạn không nhận được email?</span>
                <span onClick={() => resendOtp()}>Gửi lại</span>
              </div>


              <Button
                style={{ marginTop: "30px" }}
                htmlType="submit"
                type="primary"
                size="large"
                className="full login-button"
              >
                <span>Xác nhận</span>
              </Button>
            </Form>
          </div>
        </div>
        <Footer />
      </div>
    </Spin>
  );
}
